var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgListvehiclestep2Icon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b,.c{fill:none;}.b{stroke:#8ac43d;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.c{opacity:0;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-609 -1419)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 30,
    cy: 30,
    r: 30,
    transform: "translate(609 1419)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(385 1243)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(236 188)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M10.5,30h9C27,30,30,27,30,19.5v-9C30,3,27,0,19.5,0h-9C3,0,0,3,0,10.5v9C0,27,3,30,10.5,30Z",
    transform: "translate(3 3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M3,19.5a3.009,3.009,0,0,0,3-3V3A3,3,0,0,0,0,3V16.5A3,3,0,0,0,3,19.5Z",
    transform: "translate(20.25 8.25)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M3,11.25a3.009,3.009,0,0,0,3-3V3A3,3,0,0,0,0,3V8.25A3,3,0,0,0,3,11.25Z",
    transform: "translate(9.75 16.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M0,0H36V36H0Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListvehiclestep2Icon);
export default __webpack_public_path__ + "static/media/listvehiclestep2icon.0057b8e282c0ced1bb4eeaea108c9e41.svg";
export { ForwardRef as ReactComponent };